/* tslint:disable:interface-over-type-literal */
import {LengthInterval} from "./components/filters/LengthIntervalFilterField";
import {LengthUnit} from "../metamodel/Fields/LengthIntervalField";

export type EntityFacets = {[fieldId: string]: FieldFacet}
export type FieldFacet = {[option:string]: number}

export type EntityFilters = {[fieldId: string]: SearchFilter}

export interface IOption {
    key: string,
    name: string
}

export type SearchFilter = string | LengthInterval | string[] | number | boolean | undefined;

export class UnitValue {
    public readonly value?: number;
    public readonly unit: LengthUnit;

    constructor(value: number | undefined, unit: LengthUnit) {
        this.value = value;
        this.unit = unit;
    }

    public getRawValue() {
        let multiply = 1;
        switch (this.unit) {
            case "mm":
                multiply = 1;
                break;
            case "cm":
                multiply = 10;
                break;
            case "m":
                multiply = 1000;
                break;
            case "km":
                multiply = 1000000;
                break;

        }
        return Math.floor((this.value || 0) * multiply);
    }
}


// WEBPACK FOOTER //
// ./src/homepage/types.tsx